import { Typography } from "@mui/material";
import globalClasses from "../../commoncomponents/css/Global.module.css";
const PaymentFailed =()=>{
    return (
        <>
          <Typography variant="h6" className={globalClasses.typography}>
            Payment Failed!!!
          </Typography>
        </>
      );
}

export default PaymentFailed;